module.exports = __webpack_public_path__ + "img/sp_menu_logo.73cfb258.svg";